export class ChathamLogo extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.chathamLogo = scene.add.sprite(0, 0, 'ui', 'chatham_logo').setOrigin(0.5);
    this.add(this.chathamLogo);
  }

  get displayWidth() {
    return this.chathamLogo.width * this.scale;
  }

  get displayHeight() {
    return this.chathamLogo.height * this.scale;
  }

  destroy() {
    super.destroy();
  }
}
